import { gql } from '@apollo/client';
import { DEPARTMENT_DETAIL_FIELDS } from '../../fragments';

export const GET_DEPARTMENT_BY_ID = gql`
  ${DEPARTMENT_DETAIL_FIELDS}
  query GetDepartmentById($departmentId: ID!){
    departmentById(departmentId:$departmentId){
      ...DepartmentDetailFields
    }
  }
`;
